<template lang="pug">
section.cadastro-territorio
    BaseHeader(
        :titulo='$t("mensagens.territorio.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container-base-header
        .row.m-0
            el-form.formContainer.w-100.mb-3
                .form-header
                    h2.titulo {{ $t('mensagens.territorio.informacoesCadastrais') }}
                    p.form-description {{ $t('mensagens.territorio.informacoesCadastraisDescricao') }}

                .form-section
                    .form-group
                        .form-row
                            el-form-item.form-field(
                                :label='$t("mensagens.territorio.labels.nomeFazenda")',
                                :rules='[{ required: true, trigger: "blur" }]'
                            )
                                el-input(
                                    v-model='territorio.nome',
                                    @blur='$v.territorio.nome.$touch()',
                                    :placeholder='$t("mensagens.territorio.labels.nomeFazenda")',
                                    :class='{ "error-border": $v.territorio.nome.$error }',
                                    size='large'
                                )
                                .error(
                                    v-if='$v.territorio.nome.$error && !$v.territorio.nome.required'
                                ) {{ $t('mensagens.territorio.nomeNecessario') }}

                            el-form-item.form-field(
                                :label='$t("mensagens.territorio.labels.pessoaVinculada")'
                            )
                                el-select.w-100(
                                    v-model='territorio.representantes',
                                    multiple,
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    filterable,
                                    remote,
                                    reserve-keyword,
                                    :remote-method='remoteMethod',
                                    :loading='loading',
                                    @change='handleChangeSelectInput($event)',
                                    value-key='id',
                                    ref='elselectinput',
                                    size='large'
                                )
                                    el-option(
                                        v-for='representante in options',
                                        :key='"representante" + representante.id',
                                        :value='representante',
                                        :label='representante.nomeRazaoSocial'
                                    ) {{ representante.nomeRazaoSocial }}

                    .form-group
                        .form-row
                            el-form-item.form-field(
                                :label='$t("mensagens.territorio.labels.padron")'
                            )
                                el-input(
                                    v-model='camposParaguay.padron',
                                    @blur='$v.camposParaguay.padron.$touch()',
                                    :placeholder='$t("mensagens.territorio.labels.padron")',
                                    :class='{ "error-border": $v.camposParaguay.padron.$error }',
                                    size='large'
                                )

                            el-form-item.form-field(
                                :label='$t("mensagens.territorio.labels.finca")'
                            )
                                el-input(
                                    v-model='camposParaguay.finca',
                                    :placeholder='$t("mensagens.territorio.labels.finca")',
                                    size='large'
                                )

                            el-form-item.form-field(
                                :label='$t("mensagens.territorio.labels.codigoLyra")'
                            )
                                el-input(
                                    v-model='territorio.codigoLyra',
                                    disabled,
                                    size='large'
                                )

                InformacaoAgricula(
                    :options='territorio.informacoesAgricolas',
                    :cultivos='cultura',
                    @update='updateArea',
                    @delete='deleteArea'
                )

        .row.m-0.mb-3
            .col-4.formContainer
                h2.text-left.py-4 {{ $t('mensagens.territorio.informacoesEspaciais') }}

                el-collapse(accordion, v-model='activeForms')
                    el-collapse-item(
                        :title='$t("mensagens.territorio.uploadArquivosVetoriais")',
                        name='CASE2'
                    )
                        .row.m-0.d-flex.flex-row
                        el-upload.upload-demo(
                            drag,
                            :file-list='fileList',
                            action='alert',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :on-remove='onRemoveFile',
                            ref='upload',
                            :disabled='territorioData.value === "edit"',
                            :style='{ opacity: territorioData.value === "edit" ? 0.3 : 1 }'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text {{ $t('mensagens.territorio.dragAndDrop.1') }}<em>{{ $t('mensagens.territorio.dragAndDrop.2') }}</em>

            .col-8.pr-0
                .mapa(
                    :class='{ locked: territorioData.value === "edit" }',
                    :style='{ opacity: territorioData.value === "edit" ? 0.3 : 1 }'
                )
                    mapa.map-content(
                        :mapLayersConfigs='layersMaps',
                        :mapConfig='mapConfig',
                        :idMapa='"mapaAddTerritorio"',
                        :height='"625px"',
                        @draw-created='adicionarDesenho',
                        @draw-edited='desenhosAlterados',
                        @removerTerritorio='removerTerritorio',
                        :deslocarPopup='true',
                        :menuMaior='true',
                        :cadastroTerritorio='true',
                        ref='mapa'
                    )

        .row
            listAreasTable(
                country='PY',
                :desabilitar-remocao='territorioData.value === "edit"',
                @delete-upload-file='deleteUploadFile',
                @click-delete-area='clearSobreposicaoTerritorio',
                @set-localidades='setLocalidades',
                ref='table'
            )
        UploadArquivos(
            @add='addFile',
            @delete='deleteFile',
            :items='territorio.arquivosTerritorio'
        )

        .row.justify-content-end.py-3.m-0
            el-tooltip(
                effect='dark',
                :content='$t("mensagens.territorio.preencherCamposObrigatorios")',
                placement='top-start',
                :class='{ "item btn-disabled": this.$v.territorio.$invalid || this.territoryTableData.length !== 1 || this.territorioSobrePostoMessage }',
                :disabled='!(this.$v.territorio.$invalid || this.territoryTableData.length !== 1)'
            )
                el-button(
                    v-if='this.isAdding',
                    type='primary',
                    @click='addTerritorio',
                    style='width: 104px'
                )
                    | {{ $t('mensagens.comuns.cadastrar') }}
                el-button(
                    v-else,
                    type='primary',
                    @click='updateTerritorio',
                    style='width: 104px'
                )
                    | {{ $t('mensagens.comuns.salvar') }}

    div(v-if='dialogListaTerritoriosBaseVegaSelect')
        ModalSelecionarTerritoriosBaseVegaSobrepostosPY(
            v-if='dialogListaTerritoriosBaseVegaSelect',
            :show='dialogListaTerritoriosBaseVegaSelect',
            :territoriosBaseVega='territoriosBaseVegaComInterseccao',
            :geometriaTerritorio='territorio.geoJson',
            :is-edit='territorioData.value === "edit"',
            @voltar='dialogListaTerritoriosBaseVegaSelect = false',
            @salvar='salvarTerritorioBaseVegaEscolhido'
        )

    el-dialog.dialog-lista-select(
        :visible.sync='territorioSobrePosto',
        :title='$t("mensagens.territorio.territorioSobreposto")',
        :close-on-click-modal='false',
        :close-on-press-escape='true',
        :destroy-on-close='true',
        :show-close='true',
        width='565.8px'
    )
        p.pre-formatted {{ this.territorioSobrePostoMessage }}
        .d-flex.flex-direction.justify-content-between.posicao-botao
            el-button(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            el-button(
                slot='footer',
                size='mini',
                type='primary',
                @click='continuarTerritorioSobreposto'
            ) {{ $t('mensagens.comuns.continuar') }}
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { get } from 'lodash';
import L from 'leaflet';
import { mapActions, mapGetters, mapState } from 'vuex';

import territorioService from '@/services/TerritorioService';
import representanteService from '@/services/RepresentanteService';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import CulturaService from '@/services/CulturaService.js';

import geometryConverter from '@/utils/conversorGeometrias';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import geometryUtils from '@/utils/mapa/geometry.js';
import union from '@turf/union';
import { polygon as turfPolygon } from '@turf/helpers';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import EventBus from '@/utils/eventBus';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

import Mapa from '@/components/MapaLeaflet';
import ModalSelecionarTerritoriosBaseVegaSobrepostosPY from '@/components/territorio/ModalSelecionarTerritoriosBaseVegaSobrepostosPY';
import listAreasTable from '@/components/listAreasTable/ListAreasTable';
import InformacaoAgricula from '@/components/territorio/InformacaoAgricula.vue';
import BaseHeader from '@/components/BaseHeader';
import EmptyResult from '@/components/EmptyResult';
import ComercializacaoTerritorio from '@/components/territorio/Comercializacao';
import UploadArquivos from '@/components/territorio/UploadArquivos.vue';

export default {
    name: 'CadastrarEditarTerritorio',
    components: {
        BaseHeader,
        EmptyResult,
        Mapa,
        listAreasTable,
        ModalSelecionarTerritoriosBaseVegaSobrepostosPY,
        ComercializacaoTerritorio,
        UploadArquivos,
        InformacaoAgricula
    },
    data() {
        return {
            dataLoaded: false,
            isAdding: null,
            isAddingOrEditingTerritorio: true,
            isIgnoreSobreposition: false,
            territorio: {
                nome: null,
                representantes: [],
                city: null,
                state: null,
                area: null,
                comercializacoes: null,
                certificacoes: null,
                idCliente: null,
                informacoesAgricolas: [],
                arquivosTerritorio: [],
                codigoLyra: ''
            },
            carregandoDadosDistritoParaguay: false,
            camposParaguay: {
                departamento: null,
                distrito: null,
                padron: null,
                finca: null,
                idVegaPy: 0
            },
            addTerritorioSuccess: false,
            selectedTerritorio: {},
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    popupControl: true,
                    drawControl: true
                },
                dontZoomIn: true,
                fitBounds: true,
                addLimitesEstado: false,
                inspecionar: true
            },
            actionType: 'Cadastrar',
            activeForms: [],
            fileList: [],
            representanteData: [],
            representanteSelecionado: null,
            pageToFetch: 0,
            ativo: false,
            resultados: [],
            geometria: null,
            loading: false,
            options: [],
            sendToMonitormanetoModal: false,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 5
            },
            arquivosUploads: [],
            geometryDesenho: '',
            dialogListaTerritoriosBaseVegaSelect: false,
            territorioSobrePosto: false,
            territorioSobrePostoMessage: null,
            territorioInicial: {},
            layersMaps: [],
            dados: {
                carEstadoPaginado: [],
                existemDados: false
            },
            tipoCertificacao: [],
            listaTerritoriosComIntersecaoPY: [],
            territoriosBaseVegaComInterseccao: [],
            validacaoBaseCatastroRealizadaPY: false,
            ambientes: AmbientesEmpresas,
            cultura: [],
            informacoesAgricolas: [],
            geometriaRemanescente: null
        };
    },
    validations: {
        territorio: {
            nome: {
                required
            },
            idCliente: {}
        },
        camposParaguay: {
            departamento: {
                required: false
            },
            distrito: {
                required: false
            },
            padron: {
                required: false
            }
        }
    },
    mounted() {
        const { getters } = this.$store;
        const representante = getters.representante;

        this.fetchTerritorios();
        this.fetchRepresentantes();
        this.fetchTipoCertificacao();
        this.getCultura();

        if (!this.territorio.informacoesAgricolas) {
            this.territorio.informacoesAgricolas = [];
        }

        if (this.territorioData.value === 'edit') {
            this.territorioInicial = this.territorioData.geometria;

            const sanitizeValue = value =>
                value !== 'null' && value !== null && value !== undefined
                    ? value
                    : '';

            this.camposParaguay.padron = sanitizeValue(
                this.territorioData.padron
            );
            this.camposParaguay.finca = sanitizeValue(
                this.territorioData.finca
            );
        }

        this.$bus.$on('comercializacao', data => {
            this.territorio.comercializacoes = data;
        });

        if (this.$route.params.cadastrar) {
            this.mostrarModalEditarCadastrarRepresentante = true;
            this.editar = false;
            this.territorio.nome = this.$route.params.cadastrar;
        }

        if (representante.id) {
            const repr = this.options.findIndex(
                item => item.id === representante.id
            );
            if (repr) {
                this.options.push({ ...representante });
            }

            if (typeof representante.tipoDocumento === 'object') {
                representante.idTipoDocumento = representante.tipoDocumento.id;
            }
            this.territorio.representantes.push({ ...representante });
            this.removeRepresentante();
        }
    },

    beforeDestroy() {
        this.setRepresentante({
            id: null,
            usuario: null,
            idUsuario: null,
            nomeRazaoSocial: null,
            cpfCnpj: null,
            idCliente: null,
            email: null,
            ativo: null,
            dataCadastro: null,
            dataAtualizacao: null,
            empresas: null,
            cpfCnpjCrypt: null
        });
        this.territorio = null;
        this.limparTerritorioData();
    },

    beforeUnmount() {
        this.territorio = null;
    },

    created() {
        EventBus.$on(
            'mapa:desativar-se-ativo-selecao',
            this.desativarSelecaoSeAtivo
        );
    },
    computed: {
        ...mapGetters([
            'territorioData',
            'territoryTableData',
            'representante',
            'usuarioLogado'
        ]),
        ...mapState(['usuarioLogado']),
        pagedTableData() {
            return this.tableData.slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
            );
        },
        tipoBotao() {
            return this.ativo ? 'default' : 'primary';
        },
        textoBotao() {
            return this.ativo
                ? this.$t('mensagens.territorio.desativarSelecaoMapa')
                : this.$t('mensagens.territorio.ativarSelecaoMapa');
        }
    },
    watch: {
        search() {
            if (!this.search) {
                this.total = this.tableData.length;
                return this.tableData;
            }
            this.page = 1;
            this.total = this.pagedTableData.length;
            return this.tableData.filter(
                data =>
                    !this.search ||
                    data.nomeRazaoSocial
                        .toLowerCase()
                        .includes(this.search.toLowerCase())
            );
        },
        territoryTableData() {
            this.fitBoundsGeometriasTabela();
        }
    },
    methods: {
        closeDialog() {
            this.territorioSobrePosto = false;
        },

        ...mapActions([
            'setRepresentante',
            'setTerritoryTableData',
            'clearTerritoryTableData',
            'clearTerritorio',
            'replaceTerritoryTableData',
            'removeTerritoryTableData',
            'removeRepresentante',
            'limparTerritorioData'
        ]),

        async getCultura() {
            try {
                const { data } = await CulturaService.buscarCultura();
                this.cultura = data;
            } catch (error) {}
        },

        addFile(file) {
            const { arquivosTerritorio } = this.territorio;

            const countFilesByType = isProdutor =>
                arquivosTerritorio.filter(
                    arquivo => arquivo.arquivoProdutor === isProdutor
                ).length;

            const isBelowLimit = isProdutor => countFilesByType(isProdutor) < 3;

            if (isBelowLimit(file.arquivoProdutor)) {
                arquivosTerritorio.push(file);
            }
        },

        deleteFile(fileId) {
            const index = this.territorio.arquivosTerritorio.findIndex(item => {
                if (item?.arquivo) {
                    return item.arquivo.id === fileId;
                }

                return item.id === fileId;
            });

            if (index !== -1) {
                this.territorio.arquivosTerritorio.splice(index, 1);
            }
        },

        updateArea(params) {
            this.territorio.informacoesAgricolas.push(params);
        },

        deleteArea(index) {
            this.territorio.informacoesAgricolas.splice(index, 1);
        },
        removerTerritorio(identificadorGeometria) {
            this.territoryTableData.forEach((item, index) => {
                if (identificadorGeometria === item.identificadorGeometria) {
                    this.removeTerritoryTableData(index);
                }
            });
        },

        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },

        deleteUploadFile(name) {
            this.$refs.upload.uploadFiles =
                this.$refs.upload.uploadFiles.filter(f => f.name !== name);
            this.onRemoveFile({ name });
        },

        fetchTerritorios() {
            if (this.territorioData.value === 'edit') {
                this.territorio = this.territorioData;
                this.territorio.informacoesAgricolas =
                    this.territorioData.informacaoAgricolaPY;
                this.addPropSafraComercializacoes();
                this.isAdding = false;
                this.setMapGeometry();
            } else {
                this.clearAll();
                this.isAdding = true;
            }
            this.dataLoaded = true;
        },

        clearSobreposicaoTerritorio() {
            this.territorioSobrePostoMessage = null;
            this.territorioSobrePosto = false;
        },

        setLocalidades(localidades) {
            this.camposParaguay.departamento = localidades.codigoDepartamento;
            this.camposParaguay.distrito = localidades.codigoDistrito;
        },

        async addTerritorio() {
            this.$v.territorio.$touch();
            this.validacaoTerritorioParaguay();
        },

        async validacaoTerritorioParaguay() {
            try {
                this.$v.camposParaguay.$touch();
                if (!this.checkIfIsValid()) {
                    return;
                }

                this.territorio.geoJson = this.territoryTableData[0].geometry;

                this.clearSobreposicaoTerritorio();

                await this.validaSobreposicaoBaseVegaPY();
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoSalvarTerritorio'
                    )
                });
            }
        },

        async validaSobreposicaoBaseVegaPY() {
            try {
                const response = await territorioService.validaSobreposicaoBaseVegaPY(
                        this.territorio.geoJson
                    );

                const { data } = response;

                this.geometriaRemanescente = data.geometriaRemanescente || null;

                if (response && !data?.possuiSobreposicao) {
                    await this.salvarTerritorioParaguay();
                }

                this.territorio.geoJson = this.territoryTableData[0].geometry;
                this.territoriosBaseVegaComInterseccao = data.itens;
                this.dialogListaTerritoriosBaseVegaSelect = true;
            } catch (error) {
                this.$notify.error({
                    message: get(error, 'response.data.message', error.message)
                });
            }
        },

        async validaIntersecoesTerritoriosParaguay() {
            const idTerritorio =
                this.territorioData.value === 'edit' ? this.territorio.id : 0;

            const response =
                await territorioService.validaIntersecoesTerritoriosParaguay(
                    this.territorio.geoJson,
                    idTerritorio
                );
            this.listaTerritoriosComIntersecaoPY = response.data;
        },

        async salvarTerritorioParaguay() {
            if (!this.validarComercializacao()) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.territorio.itemComercializacaoCampoObrigatorio'
                    )
                });
                return;
            }

            this.removePropSafraComercializacoes();
            this.territorio.geometriaRemanescente = this.geometriaRemanescente ?? null;

            if (this.territorioData.value === 'edit') {
                territorioService
                    .updateParaguay(this.territorio, this.camposParaguay)
                    .then(response => {
                        this.updateTerritorioModal = false;
                        this.isAddingOrEditingTerritorio = false;
                        this.fetchTerritorios();
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioEditadoSucesso'
                            )
                        });
                        this.$router.push({ name: 'Territorio' });
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: get(
                                error,
                                'response.data.message',
                                error.message
                            )
                        });
                    });
            } else {
                try {
                    const arquivos = this.territorio.arquivosTerritorio || [];

                    const filesProdutor = arquivos
                        .filter(a => a && a.arquivoProdutor === true)
                        .map(a => a.raw || a.file || a.arquivo)
                        .filter(Boolean);

                    const filesEmpresa = arquivos
                        .filter(a => a && a.arquivoProdutor === false)
                        .map(a => a.raw || a.file || a.arquivo)
                        .filter(Boolean);

                    this.territorio.geometriaRemanescente = this.geometriaRemanescente ? JSON.stringify(this.geometriaRemanescente) : null;

                    await territorioService.addParaguay(
                        this.territorio,
                        this.camposParaguay,
                        filesProdutor,
                        filesEmpresa
                    );

                    this.isAddingOrEditingTerritorio = false;
                    this.addTerritorioSuccess = true;
                    this.territorio.representantes = [];

                    this.$notify.success({
                        message: this.$t(
                            'mensagens.territorio.territorioAdicionadoSucesso'
                        )
                    });

                    this.$router.push({ name: 'Territorio' });
                } catch (erro) {
                    const backendMsg = get(erro, 'response.data.message', null);
                    const status = get(erro, 'response.status', null);
                    const raw = get(erro, 'message', String(erro));
                    this.camposParaguay.idVegaPy = 0;

                    this.$notify.error({
                        message: backendMsg || `Falha ao salvar (${status || 'sem status'}): ${raw}`
                    });
                }
            }
        },

        async realizarDiagnostico(territorio) {
            await DiagnosticoSocioambientalService.realizarDiagnosticoCadastroTerritorio(
                territorio.id
            );
        },

        async continuarTerritorioSobreposto() {
            this.isIgnoreSobreposition = true;
            this.clearSobreposicaoTerritorio();
            this.addTerritorio();
            this.closeDialog();
        },

        async updateTerritorio() {
            this.$v.territorio.$touch();
            this.validacaoTerritorioParaguay();
        },

        onLoadFile(file) {
            let reader = new FileReader();
            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria, file.name);

                        this.arquivosUploads.push({
                            id: file.uid,
                            layer: geometria,
                            name: file.name
                        });
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        processarGeometria(geometria, fileName) {
            this.filtrarGeometrias(geometria);

            if (geometria === null || geometria.getLayers().length === 0) {
                this.notificarArquivoInvalido();
                return;
            }

            const coordenadas = [];
            this.coletarCoordenadasPolygon(geometria, coordenadas);

            if (coordenadas.length === 0) {
                this.notificarArquivoInvalido();
                return;
            }

            const geometriaUnica = this.dissolverPoligonos(coordenadas);

            if (geometriaUnica === null) {
                this.notificarArquivoInvalido();
                return;
            }

            const camadaCalculada = L.geoJSON(geometriaUnica).getLayers()[0];

            this.setTerritoryTableData({
                identificadorGeometria: geometria._leaflet_id,
                type: 'UPLOAD',
                codigo: 'UPLOAD',
                area_ha: geometryUtils.calcularAreaHaFromLayer(camadaCalculada),
                geometry: geometriaUnica,
                fileName
            });
            this.clearSobreposicaoTerritorio();

            geometria.setStyle({ color: 'red' });
            this.$refs.mapa.mapa.addLayer(geometria);
            this.$refs.mapa.mapa.fitBounds(geometria.getBounds());
        },

        coletarCoordenadasPolygon(layerGroup, acc) {
            layerGroup.getLayers().forEach(layer => {
                if (layer.getLayers) {
                    this.coletarCoordenadasPolygon(layer, acc);
                    return;
                }

                const geometriaLayer = this.verificaTipoCorretoGeometria(
                    layer.feature?.geometry || layer.toGeoJSON().geometry
                );

                if (geometriaLayer?.type === 'Polygon') {
                    acc.push(geometriaLayer.coordinates);
                } else if (geometriaLayer?.type === 'MultiPolygon') {
                    acc.push(...geometriaLayer.coordinates);
                }
            });
        },

        dissolverPoligonos(coordenadas) {
            try {
                const geometriaDissolvida = coordenadas
                    .map(coords => turfPolygon(coords))
                    .reduce(
                        (acumulado, poligono) =>
                            acumulado === null
                                ? poligono
                                : union(acumulado, poligono),
                        null
                    );

                return geometriaDissolvida ? geometriaDissolvida.geometry : null;
            } catch (error) {
                return null;
            }
        },

        notificarArquivoInvalido() {
            this.$refs.upload.clearFiles();
            this.$notify.error({
                message: this.$t(
                    'mensagens.territorio.arquivoNaoPossuiGeometriaValida'
                )
            });
        },
        /* Permite apenas Features e Geometries do tipo '(Multi)Polygon' */
        filtrarGeometrias(layerGeometrias) {
            if (!layerGeometrias) return;

            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }

                        if (layer instanceof L.Polyline) {
                            const coordinates = layer.getLatLngs();
                            if (!this.isValidLatLngArray(coordinates)) {
                                return;
                            }

                            return this.filtrarGeometrias(layer);
                        }

                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },
        isValidLatLngArray(latlngArray) {
            if (!Array.isArray(latlngArray) || latlngArray.length === 0) {
                return false;
            }
            return latlngArray.every(coord => {
                if (Array.isArray(coord)) {
                    return this.isValidLatLngArray(coord);
                }
                return (
                    coord &&
                    coord.lat !== undefined &&
                    coord.lng !== undefined &&
                    coord.lat >= -90 &&
                    coord.lat <= 90 &&
                    coord.lng >= -180 &&
                    coord.lng <= 180
                );
            });
        },

        verificaTipoCorretoGeometria(geometria) {
            if (geometria.type === 'LineString') {
                const coordinates = [...geometria.coordinates];
                if (coordinates.length === 0) return null;

                coordinates.push(coordinates[0]);

                return {
                    type: 'Polygon',
                    coordinates: [coordinates]
                };
            }

            return geometria;
        },

        onRemoveFile(file) {
            const fileName = file?.name;
            if (!fileName) {
                return;
            }

            const itemToRemove = this.arquivosUploads.find(
                o => o.name === fileName
            );
            if (itemToRemove) {
                this.$refs.mapa.mapa.removeLayer(itemToRemove.layer);
            }
            this.arquivosUploads = this.arquivosUploads.filter(
                o => o.name !== fileName
            );

            const indices = [];
            this.$refs.table.territoryTableData.forEach((d, i) => {
                if (d.fileName === fileName) {
                    indices.push(i);
                }
            });
            indices
                .reverse()
                .forEach(i => this.$refs.table.removeTerritoryTableData(i));
        },

        getFiltros(query) {
            const filtro = {};
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.searchText = query || '';
            if (query && validators.validarCpf(query)) {
                filtro.searchText = formatters.cpfCnpjFormatToNumeral(query);
            }
            filtro.order = '&sort=nome_razao_social,asc';
            return filtro;
        },

        async fetchRepresentantes(query) {
            try {
                const { data } = await representanteService.findAllByFiltro(
                    this.getFiltros(query)
                );
                this.representanteData = this.representanteData.concat(
                    data.itens
                );
                this.representanteData = this.representanteData.filter(
                    (v, i, a) => a.findIndex(t => t.id === v.id) === i
                );
                this.options = data.itens.slice(0, 5);
                if (this.territorioData.value === 'edit') {
                    let intersection = [];
                    let difference = [];
                    this.options.forEach(value => {
                        this.territorio.representantes.forEach(item => {
                            if (item.id === value.id) {
                                intersection.push(item);
                            }
                        });
                    });
                    difference = this.territorio.representantes.filter(
                        value => !intersection.includes(value)
                    );
                    this.options.push(...difference);
                }

                if (this.representante.id) {
                    const repr = this.options.findIndex(
                        item => item.id === this.representante.id
                    );
                    if (repr) {
                        this.options.push({ ...this.representante });
                    }
                }
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.erroAoBuscarPessoas')
                });
            } finally {
                this.loading = false;
            }
        },

        async fetchTipoCertificacao() {
            try {
                const { data } =
                    await territorioService.buscarTipoCertificacao();
                this.tipoCertificacao = data;
            } catch (e) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.territorio.erroAoBuscarTiposCertificacao'
                    )
                });
            }
        },

        toggleSelecao() {
            this.ativo = !this.ativo;
            if (this.ativo) {
                this.ativarSelecao();
            } else {
                this.desativarSelecao();
            }
        },
        desativarSelecaoSeAtivo() {
            if (this.ativo) {
                this.desativarSelecao();
                this.ativo = false;
            }
        },
        ativarSelecao() {
            this.$bus.$emit('mapa:ativar-camada-onclick-car');
        },
        desativarSelecao() {
            EventBus.$emit('cadastro-territorio:fechar-modal-car-selecionado');
            this.$bus.$emit('mapa:desativar-camada-onclick-car');
            this.territorio.geoJson = null;
            this.fitBoundsGeometriasTabela();
        },
        fitBoundsGeometriasTabela() {
            if (
                this.territoryTableData.length &&
                this.$refs &&
                this.$refs.mapa &&
                this.$refs.mapa.mapa
            ) {
                const group = new L.FeatureGroup();
                this.territoryTableData.forEach(territorioTabela => {
                    group.addLayer(L.geoJSON(territorioTabela.geometry));
                });
                this.$refs.mapa.mapa.fitBounds(group.getBounds());
            }
        },
        setMapGeometry() {
            const identificadorGeometria = new Date().getTime();

            const territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.type = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.codigo = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.area_ha =
                this.territorioData.areaHa;
            territoryPropertyConverionToTableData.geometry =
                this.territorioData.geometria;
            territoryPropertyConverionToTableData.identificadorGeometria =
                identificadorGeometria;

            this.clearTerritoryTableData();
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            this.mostrarTerritorioNoMapa(
                this.territorioData.geometria,
                identificadorGeometria
            );
        },

        mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            this.layersMaps = [];

            geometria.identificadorGeometria = identificadorGeometria;

            const layerTerritorio = {
                style: mapaEstilos.Geometria.imovelRuralCandidato,
                name: identificadorGeometria,
                geoJson: geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        clearAll() {
            this.clearTerritoryTableData();
            this.territorio.nome = null;
            this.clearTerritorio();
        },
        remoteMethod(query) {
            this.loading = true;
            setTimeout(() => {
                this.fetchRepresentantes(query);
            }, 800);
        },

        handleChangeSelectInput() {
            this.$nextTick(() => {
                this.$refs.elselectinput.query = '';
            });
        },

        checkIfIsValid() {
            if (
                this.$v.territorio.$invalid ||
                this.territoryTableData.length !== 1
            ) {
                if (
                    this.$v.territorio.$invalid ||
                    (this.permissaoAmbiente(this.ambientes.PARAGUAY) &&
                        this.$v.camposParaguay.$invalid)
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.verifiqueCamposObrigatorios'
                        )
                    });
                    return false;
                }

                if (this.$v.territorio.$invalid) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.verifiqueCamposObrigatorios'
                        )
                    });
                    return false;
                }
                if (this.territoryTableData.length !== 1) {
                    // Need this so we don't overlap notifications
                    setTimeout(() => {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.verifiqueTerritoriosConsolidados'
                            )
                        });
                    }, 200);
                    return false;
                }
            }
            if (this.territorioSobrePostoMessage) {
                this.territorioSobrePosto = true;
                return false;
            }

            return true;
        },

        adicionarDesenho(desenho) {
            let territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.identificadorGeometria =
                desenho._leaflet_id;
            desenho.identificadorGeometria = desenho._leaflet_id;

            territoryPropertyConverionToTableData.type = 'Desenho de geometria';
            territoryPropertyConverionToTableData.codigo = 'DESENHO';
            territoryPropertyConverionToTableData.area_ha =
                geometryUtils.calcularAreaHaFromLayer(desenho);
            territoryPropertyConverionToTableData.geometry =
                desenho.toGeoJSON().geometry;

            this.geometryDesenho = desenho.toGeoJSON().geometry;
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();
        },

        desenhosAlterados(desenhosAlterados) {
            desenhosAlterados.eachLayer(layer => {
                const areaHa = geometryUtils.calcularAreaHaFromLayer(layer);
                const geometry = layer.toGeoJSON().geometry;
                this.territoryTableData.findIndex(
                    t => t.identificadorGeometria === layer._leaflet_id
                );
                this.replaceTerritoryTableData({
                    identificadorGeometria: layer._leaflet_id,
                    geometry,
                    areaHa
                });
            });
        },

        salvarTerritorioBaseVegaEscolhido(territorioBaseVegaSelecionado) {
            this.camposParaguay.idVegaPy = territorioBaseVegaSelecionado.idVega;
            this.dialogListaTerritoriosBaseVegaSelect = false;
            this.atualizaGeometria(territorioBaseVegaSelecionado);
            this.salvarTerritorioParaguay();
        },

        atualizaGeometria(territorioBaseVegaSelecionado) {
            const territoryPropertyConverionToTableData = {};
            territoryPropertyConverionToTableData.type = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.codigo = 'AREA_CONSOLIDADA';
            territoryPropertyConverionToTableData.area_ha =
                territorioBaseVegaSelecionado.territorioArea;
            territoryPropertyConverionToTableData.geometry =
                territorioBaseVegaSelecionado.geometria;
            territoryPropertyConverionToTableData.identificadorGeometria =
                territorioBaseVegaSelecionado.cdTerritorio;

            this.clearTerritoryTableData();
            this.setTerritoryTableData(territoryPropertyConverionToTableData);
            this.clearSobreposicaoTerritorio();

            this.territorio.geoJson = territorioBaseVegaSelecionado.geometria;

            this.mostrarTerritorioNoMapa(
                territorioBaseVegaSelecionado.geometria,
                territorioBaseVegaSelecionado.cdTerritorio
            );
        },

        validarComercializacao() {
            let valido = true;
            if (this.territorio.comercializacoes) {
                for (
                    var i = 0;
                    i < this.territorio.comercializacoes.length;
                    i = i + 1
                ) {
                    if (
                        !this.territorio.comercializacoes[i].produto.id ||
                        this.territorio.comercializacoes[i].quantidade === 0 ||
                        !this.territorio.comercializacoes[i].unidadeMedida.id
                    ) {
                        valido = false;
                    }
                    if (
                        !this.territorio.comercializacoes[i].produto.id &&
                        this.territorio.comercializacoes[i].quantidade === 0 &&
                        !this.territorio.comercializacoes[i].unidadeMedida.id &&
                        i === 0
                    ) {
                        valido = true;
                    }
                }
            }
            return valido;
        },

        addPropSafraComercializacoes() {
            if (this.territorio.comercializacoes) {
                this.territorio.comercializacoes.forEach(comercializacao => {
                    if (!comercializacao.safra) {
                        comercializacao.safra = {};
                    }
                });
            }
        },

        removePropSafraComercializacoes() {
            if (
                this.territorio.comercializacoes &&
                this.territorio.comercializacoes.length > 0
            ) {
                this.territorio.comercializacoes.forEach(comercializacao => {
                    if (Object.keys(comercializacao.safra).length === 0) {
                        delete comercializacao.safra;
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
.cadastro-territorio {
    display: flex;
    flex-direction: column;

    button {
        width: fit-content;
        cursor: pointer;
    }

    .required-text {
        color: var(--danger);
    }

    .m-25 {
        margin-top: 25px;
    }
}

.posicao-botao {
    display: flex;
    justify-content: space-between;
}

.formContainer {
    background-color: var(--white);
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border: 1px solid #e8e8e8;

    .form-header {
        margin-bottom: 24px;
        border-bottom: 1px solid #e8e8e8;
        padding-bottom: 16px;

        .titulo {
            font-size: 20px;
            font-weight: 600;
            color: #183b57;
            margin: 0 0 8px 0;
        }

        .form-description {
            color: #666;
            font-size: 14px;
            margin: 0;
            line-height: 1.5;
        }
    }

    .form-section {
        .form-group {
            margin: 12px 5px;
            .section-title {
                font-size: 16px;
                font-weight: 600;
                color: #183b57;
                margin: 0 0 16px 0;
                padding-bottom: 8px;
                border-bottom: 2px solid #f0f0f0;
            }

            .form-row {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                gap: 20px;
                align-items: start;

                .form-field {
                    margin-bottom: 0;

                    .el-form-item__label {
                        font-weight: 500;
                        color: #183b57;
                        margin-bottom: 8px;
                        font-size: 14px;
                    }

                    .el-input,
                    .el-select {
                        .el-input__inner {
                            border-radius: 6px;
                            border: 1px solid #d9d9d9;
                            transition: all 0.3s ease;

                            &:focus {
                                border-color: #409eff;
                                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                            }
                        }
                    }

                    .el-select {
                        .el-input__inner {
                            height: 40px;
                        }
                    }
                }
            }
        }
    }
}

.el-upload {
    flex: 1;

    .el-icon-upload {
        font-size: 40px;
        margin: 0px;
    }
}

.el-collapse-item {
    border-bottom: 1px solid #ebeef5;
}

.el-upload-dragger {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: column !important;
}

.el-form-item__label {
    margin-bottom: 0px;
}

.left .el-tooltip__popper,
.right .el-tooltip__popper {
    padding: 8px 10px;
}

.form-alignment {
    height: 108px;
}

.el-form-item.form-size.separator.my-3.is-required {
    height: 80px;
}

el-form.formContainer.w-100.mb-3.form-alignment.el-form-item__content {
    line-height: 20px;
}

.error {
    line-height: 20px;
}

.voltar {
    cursor: pointer;
    line-height: 2;
}

.mapa {
    border-radius: 4px !important;
    overflow: hidden;
    position: relative;
}

.locked * {
    cursor: not-allowed;
    pointer-events: none !important;
}

.btn-selecao-mapa-body {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        margin-right: 5px;
    }
}

.pre-formatted {
    white-space: pre-line;
}

.form-size {
    width: 100%;
}

.form-alignment {
    display: flex;
    align-items: center;
}

.separator {
    margin-right: 20px;
}

.el-dialog__header {
    background: #f6f6f6 !important;
    padding-bottom: 20px !important;
}

.el-dialog__title,
.el-icon {
    color: #183b57 !important;
}

.el-dialog__body {
    color: #3b3b3b !important;
    font-size: normal !important;
    flex-direction: column;
    display: flex;
}

.territorio {
    padding: 15px 0;
    flex-direction: column;
    display: flex;
}

footer {
    display: flex;
    justify-content: space-between;
}

.invalido {
    color: var(--danger);
}

.espaco {
    display: flex;
}

.el-form-item .el-form-item__label {
    font-weight: normal !important;
}
</style>
